const SupplierRegister = () => {
  return <div style={{ padding: '0 10px' }}></div>
}

export default SupplierRegister
const SupplierRegister = () => {
  return <div style={{ padding: '0 10px' }}></div>
}

export default SupplierRegister
